import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import type { RootState } from '@/redux-toolkit/store';

// Menu key of the top-level page the user is on, sent to the tasks API as
// `page`. Empty when the route isn't in the menu.
export const useHelpCurrentPage = (): string => {
  const { pathname } = useLocation();
  const menuItems = useSelector((state: RootState) => state.menu.items);

  return useMemo(() => {
    const section = pathname.split('/').filter(Boolean)[0];
    if (!section) return '';

    const match = menuItems?.find(
      (item) => item.route?.replace(/^\/+/, '').split('/')[0] === section
    );
    return match?.name ?? '';
  }, [pathname, menuItems]);
};

export default useHelpCurrentPage;
